import { render, staticRenderFns } from "./downloadIcon.vue?vue&type=template&id=4577a46c&"
import script from "./downloadIcon.vue?vue&type=script&lang=js&"
export * from "./downloadIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  ,true
)

export default component.exports